import { TestPermission, TestPermissions } from './Permissions'
export class AuthAccountInfo {
  constructor (props) {
    Object.assign(this, props)
    this.IsAuthenticated = props ? true : false // eslint-disable-line
  }

  HasPermission (permission) {
    return TestPermission(this.Permissions || [], permission)
  }

  HasPermissions (permissions, requireAll = false) {
    return TestPermissions(this.Permissions || [], permissions, requireAll)
  }
}
